import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';


export const Nav = styled.nav`
    background: transparent;
    height: 80px;
    display: flex;
    margin-top: -80px;
    align-items: center;
    font-size: 1rem;
    max-width: 100%;
    position: sticky;
    justify-content: space-between;
    top: 0;
    z-index: 10;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }

    @media screen and (max-width: ${({ theme }) => theme.tablet}) {
        background: #fff;
    }
`;

export const NavLogo = styled(LinkR)`
    justify-self: flex-start;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: 4rem;
    text-decoration: none;
`;

export const Logo = styled.h1`
    letter-spacing: 1rem;
    font-size: 3rem;
    display: flex;
    color: #000;
    padding-top: 2rem;
    margin-top: 0.1rem;
`;

export const MobileIcon = styled.div`
    display: none;
    
    @media screen and (max-width: ${({ theme }) => theme.tablet}) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
    }
`;

